<template>
  <div class="foot-box">
    <div class="foot">
      <div class="area-box">
        <div class="logo-box">
          <div class="title">联系方式</div>
          <div class="more-text">联系人：博文</div>
          <div class="more-text">手机号：18710120790</div>
          <div class="more-text">微信：shouzaitiyu</div>
          <div class="more-text">邮箱：2970206540@qq.com</div>
          <div class="more-text">地址：北京市东城区体育馆路11号</div>
        </div>
      </div>
      <div class="area-box">
        <div class="other-link">
          <div class="box-item" v-for="menu of menuList">
            <div class="title">{{ menu.title }}</div>
            <div class="menu-list">
              <div class="menu-item" v-for="item of menu.list" @click="chooseMenu(menu.type, item)">{{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-box">
        <div class="contact-us">
          <div class="title">联系人微信</div>
          <img class="person-qrcode" src="@/assets/images/qrcode/2.jpg" />
        </div>
        <div class="contact-us">
          <div class="title">首在体育公众号</div>
          <img class="person-qrcode" src="@/assets/images/qrcode/1.jpg" />
        </div>
      </div>
    </div>

    <div class="popup-box" v-if="qrcode">
      <div class="blackscreen" @click="qrcode = ''"></div>
      <div class="box-content">
        <img :src="qrcode" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'foot',
  components: {
  },
  data() {
    return {
      menuList: [
        {
          title: '友情链接（排名不分先后）',
          type: 'link',
          list: [
            { name: '国家体育总局', url: 'https://www.sport.gov.cn' },
            { name: '中国高校产业协会', url: 'https://www.caui.org.cn' },
            { name: '北京大学', url: 'https://www.pku.edu.cn' },
            { name: '北京体育大学', url: 'https://www.bsu.edu.cn' },
          ]
        }
      ],

      qrcode: ''
    }
  },
  mounted() {
    //监听store
    // this.$store.subscribe((res) => {
    //   if (!res) return;

    //   let { type, payload } = res;
    // })
  },
  methods: {
    //选择菜单
    chooseMenu(type, item) {
      if (type == 'link') window.open(item.url);
      // else this.qrcode = require(`@/assets/images/home/qrcode/${item.name}.jpg`);
    },
    //打开出版物经营许可证
    openCode(url) {
      this.qrcode = url;
    },
    //打开链接
    openUrl(url) {
      window.open(url);
    }
  }
}
</script>
<style scoped lang="scss">
@import "./foot.scss";
</style>